import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../services/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useEffect } from 'react';

/**
 * Warning banner shown when subscription is past due
 * Only visible to club admins
 */
function SubscriptionWarningBanner({ daysRemaining }) {
  const [user] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [searchParams] = useSearchParams();
  const clubParam = searchParams.get('club');

  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) return;
      
      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const role = userDoc.data().role;
          setIsAdmin(role === 'club_admin' || role === 'super_admin');
        }
      } catch (err) {
        console.error('Error checking admin status:', err);
      }
    };

    checkAdmin();
  }, [user]);

  // Only show to admins
  if (!isAdmin || dismissed) {
    return null;
  }

  return (
    <div className="subscription-warning-banner">
      <div className="warning-content">
        <span className="warning-icon">⚠️</span>
        <p>
          <strong>Payment Overdue:</strong> Your subscription payment is overdue. 
          Please pay within {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} to avoid service interruption.
        </p>
        <div className="warning-actions">
          <Link 
            to={`/admin/subscription${clubParam ? `?club=${clubParam}` : ''}`} 
            className="warning-btn pay-btn"
          >
            Pay Now
          </Link>
          <button 
            onClick={() => setDismissed(true)} 
            className="warning-btn dismiss-btn"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionWarningBanner;
